import produce from 'immer';
import { getSearchDefauls } from '@ts/utils/funcs';
import { ActionTypes } from '../actions/search';

export const initialState = {
    destinationId: null,
    destinationCategoryId: null,
    ...getSearchDefauls(),
};

/* eslint-disable no-param-reassign */
function appSearchReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case ActionTypes.CHANGE_DESTINATION:
                draft.destinationId =
                    action.destination instanceof Object ? action.destination.id : null;
                draft.destinationCategoryId =
                    action.category instanceof Object ? action.category.id : null;
                return draft;
            case ActionTypes.CHANGE_DESTINATION_ID:
                draft.destinationId = action.destinationId;
                return draft;
            case ActionTypes.CHANGE_DESTINATION_CATEGORY_ID:
                draft.destinationCategoryId = action.destinationCategoryId;
                return draft;
            case ActionTypes.CHANGE_DATE:
                draft.dateFrom = action.dateFrom || null;
                draft.dateTo = action.dateFrom && action.dateTo ? action.dateTo : null;
                return draft;
            case ActionTypes.CHANGE_DATE_FROM:
                draft.dateFrom = action.dateFrom;
                return draft;
            case ActionTypes.CHANGE_DATE_TO:
                draft.dateTo = action.dateTo;
                return draft;
            default:
                return draft;
        }
    });
}

export default appSearchReducer;
